import React, { Component } from 'react';
import { Container, Button, Form, FormGroup, Label, Input, FormFeedback, Row, Col, Card, CardBody, CardLink, Modal, ModalHeader, ModalBody, CustomInput } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import Tarjeta from '../../Componentes/Cards/docCard'
import validaciones from '../../Auxiliares/validaciones'

export default class AdminDocs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            doc: '',
            ppp: 200,
            doble_cara: false,
            switch: 'Una cara',
            errors: {},
            docs: [],
            isAddModalOpen: false,
        }
        this.toggleAdd = this.toggleAdd.bind(this)
        this.registrar = this.registrar.bind(this);
        this.actualizarLista = this.actualizarLista.bind(this)
    }

    componentDidMount() {
        this.actualizarLista();
    }

    actualizarLista(){
        Fetch('/api/getDocs', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => {
                this.setState({ docs: response.data })
            })
            .catch(err => {
                switch (err.status) {
                    case 602:
                        toast.error('No existen datos correspondientes')
                        break;
                    case 605:
                        toast.info('Lista vacia')
                        this.setState({ docs: [] })
                        break;
                    default:
                        toast.error(err)
                        break;
                }
            })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, ()=> {
            let value;
            switch([field].toString()){
                case 'doc':
                    if (validaciones.validar_titulo(this.state.doc)) {
                        value = validaciones.validar_titulo(this.state.doc)
                        this.setState(prevState => ({ errors: { ...prevState.errors, doc: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).doc) });
                    }
                break;

                case 'ppp':
                    if (validaciones.validar_resolucion(this.state.ppp)) {
                        value = validaciones.validar_resolucion(this.state.ppp)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ppp: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ppp) });
                    }
                break;

                default:
                    break;
            }
        })
    }

    setSwitchValue(e) {
        let tipo;
        if(!this.state.doble_cara){
            tipo = "Doble cara";
        }else{
            tipo = "Una cara";
        }

        this.setState(prevState =>({
            doble_cara: !prevState.doble_cara,
            switch: tipo
        }));
    }

    toggleAdd(obj) {
        this.setState(prevState => ({
            isAddModalOpen: !prevState.isAddModalOpen,
            doc: '',
            ppp: 200,
            doble_cara: false,
            switch: 'Una cara'
        }));
    }

    registrar() {
        const { doc, ppp, doble_cara } = this.state
        
        if (validaciones.sinErrores(this.state.errors)) {
            Fetch('/api/addDoc', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ doc, ppp, doble_cara })
            })
                .then(response => {
                    this.actualizarLista();
                    this.toggleAdd();
                })
                .catch(err => {
                    switch (err.status) {
                        case 600:
                            toast.error('Error inesperado')
                            break;
                        case 601:
                            toast.error('Este modulo ya existe')
                            break;
                        case 604:
                            toast.error('Error, no se ha podido registrar, verifique los campos')
                            break;

                        default:
                            toast.error(err)
                            break;
                    }
                })
        }
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light col-sm-2">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light">
                        <div id="page-content-wrapper">
                            <div class="container-fluid">
                                <Container>
                                    <Card className="mt-3 mb-3 p-4" >
                                        <h1 className="display-4">Lista de documentos</h1>
                                        <p className="lead">Esta seccion permite agregar, modificar o eliminar listado de documentos</p>
                                        <hr className="my-1" />
                                    </Card>

                                    <Row>
                                        {this.state.docs.length > 0 ? this.state.docs.map((index) => (<Col sm="3" className="mb-4"> <Tarjeta id={index._id} doc={index.doc} ppp={index.ppp} doble_cara={index.doble_cara} actualizar={this.actualizarLista} /> </Col>)) : <Col><Card className="d-flex p-5 text-center bg-secondary text-light shadow " style={{ border: 'dashed 2px' }} >Lista vacia</Card></Col>}
                                        <Col sm="3" className="d-flex">
                                            <Card className="shadow agregar" onClick={() => this.toggleAdd()}>
                                                <Col>
                                                    <div className="text-center">
                                                        <img className="my-5" width="25%" alt="icono agregar" src="https://image.flaticon.com/icons/svg/61/61183.svg" />
                                                    </div>
                                                </Col>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </div>
                    </Col>
                    {/*Modal */}
                    <Modal isOpen={this.state.isAddModalOpen} toggle={() => this.toggleAdd()}
                        className="modal-md">
                        <ModalHeader toggle={() => this.toggleAdd()}>Agregar doc</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col> 
                                    <Card className="p-3">
                                        <Container>
                                            <Form className="mx-5 mt-5">
                                                <Row style={{ display: 'flex', justifyContent: 'center', height: '100%' }} className="mb-4" >
                                                    <Col>
                                                        <FormGroup>
                                                            <Input type="text" name="doc" id="doc" placeholder="Nombre doc" className="mb-3 py-4 d-flex w-100 font-weight-bold" onChange={this.setValue.bind(this, 'doc')} invalid={this.state.errors.doc}/>
                                                            <FormFeedback>{this.state.errors.doc}</FormFeedback>
                                                        </FormGroup>
                                                        <br/>
                                                        <FormGroup>
                                                            <Label for="ppp">Resolucion del documento</Label>
                                                            <Input type="select" name="ppp" id="ppp" onChange={this.setValue.bind(this, 'ppp')}>
                                                                <option>200</option>
                                                                <option>300</option>
                                                                <option>400</option>
                                                                <option>600</option>
                                                                <option>1200</option>
                                                            </Input>
                                                            <FormFeedback>{this.state.errors.ppp}</FormFeedback>
                                                        </FormGroup>
                                                        <br/>
                                                        <FormGroup>
                                                            <Label for="doble_cara">Tipo de documento</Label>
                                                            <div>
                                                                <CustomInput type="switch" id="doble_cara" name="doble_cara" label={this.state.switch} onChange={this.setSwitchValue.bind(this)} />
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Container>

                                        <CardBody className="text-center">
                                            <CardLink><Button className="btn-info" onClick={() => this.registrar()}>Crear</Button></CardLink>
                                            <CardLink><Button className="btn-light" onClick={() => this.toggleAdd()}>Cancelar</Button></CardLink>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                </Row>
                <Footer />
            </html>
        )
    }
}
